import StudentResultOverview from "../StudentResultOverview";
import ClassResultOverview from "../ClassResultOverview";
import ProgramResultOverview from "../ProgramResultOverview";

export default function TeacherResultOverview({
  level,
  classData,
  student,
  studentId,
  studentHasLicense,
  programId,
}) {
  const renderLevel = () => {
    switch (level) {
      case "Class":
        return (
          <div>
            <ClassResultOverview classData={classData} />
          </div>
        );
      case "Student":
        if (studentHasLicense) {
          return (
            <StudentResultOverview
              studentEmail={student.email}
              studentId={studentId}
            />
          );
        } else {
          return (
            <div>
              Eleven har inga licenser och därmed inga resultat att visa.
            </div>
          );
        }
      case "Program":
        return <ProgramResultOverview programId={programId} />;

      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
